import { Injectable } from '@angular/core'
import { TmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimLineServiceAdjustment extends IModelBase {
  ClaimId: number
  ServiceId: number
  GroupCode: string
  Code: string
  Amount?: number
  Quantity?: number
}

@Injectable()
export class ClaimLineServiceAdjustmentODataService extends ODataService<IClaimLineServiceAdjustment> {
  constructor(
    protected http: HttpClient,
    protected config: TmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ServiceAdjustments'
  }
}
